import {
  ENVIRONMENT_INITIALIZER,
  EnvironmentProviders,
  inject,
  Provider
} from '@angular/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions
} from '@angular/material/form-field';
import { VexSplashScreenService } from '@vex/services/vex-splash-screen.service';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { VexPlatformService } from '@vex/services/vex-platform.service';
import { VexConfigService } from '@vex/config/vex-config.service';
import { VexThemeProvider } from '@vex/config/vex-config.interface';
import { VEX_ACCENTS, VEX_THEMES } from '@vex/config/config.token';

export function provideVex(options: {
  availableThemes: VexThemeProvider[];
  availableAccents: VexThemeProvider[];
}): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: VEX_THEMES,
      useValue: options.availableThemes
    },
    {
      provide: VEX_ACCENTS,
      useValue: options.availableAccents
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline'
      } satisfies MatFormFieldDefaultOptions
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(VexSplashScreenService),
      multi: true
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(VexLayoutService),
      multi: true
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(VexPlatformService),
      multi: true
    },
    {
      // Instancia VexConfigService en el bootstrap para que el tema (clases y
      // variables CSS en <body>) se aplique también en rutas fuera del Layout (ej. login)
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(VexConfigService),
      multi: true
    }
  ];
}
